import { ErrorHandler, Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root',
})
export class PrismeErrorService implements ErrorHandler {
    handleError(error: Error): void {
        console.log(error);
    }
}
